import { createFileRoute } from "@tanstack/react-router";
import { fleaMarketTransactionDetailQueryOptions } from "~/features/fleamarket/api";
import { FleaMarketTransactionDetailTemplate } from "~/features/fleamarket/FleaMarketTransactionDetailTemplate";

export const Route = createFileRoute(
  "/_authenticated/fleamarket/transaction/$transactionId",
)({
  loader: ({ context: { queryClient }, params: { transactionId } }) =>
    queryClient
      .ensureQueryData(fleaMarketTransactionDetailQueryOptions(transactionId))
      .catch(() => undefined),
  component: FleaMarketTransactionDetailTemplate,
});
